// 视频拍摄——主流程
const MainRoutes = Array.from({ length: 13 }, (_, i) => ({
  path: `video/index${i + 1}`,
  name: `videoIndex${i + 1}`,
  component: () => import(`@/views/travel/video/index${i + 1}.vue`)
}))

export default {
  path: '/travel',
  component: {
    render (c) {
      return c('router-view')
    }
  },
  children: [
    // 视频拍摄——主流程，开始
    ...MainRoutes

  ]
}
